import { LinearProgress } from "@mui/material";
import { makeStyles } from "@mui/styles";
import classNames from "classnames";

export interface ModuleProgressBarProps {
  /**
   * Used for aria-label
   */
  name: string;
  /**
   * The value of the progress indicator. Value between 0 and 100.
   */
  value: number | undefined;
  className?: string | undefined;

  /**
   * True if this component needs to fill the width of a space
   */
  fullWidth?: boolean;
}

const useStyles = makeStyles((theme) => ({
  moduleProgressBar: ({ fullWidth = false }: ModuleProgressBarProps) => ({
    marginTop: "0.6rem",
    maxWidth: fullWidth ? "100%" : "16rem",
    minHeight: "0.5rem",
    borderRadius: "6px",
  }),
  barColorPrimary: ({ value = 0 }: ModuleProgressBarProps) => ({
    backgroundColor:
      value === 100 ? theme.palette.primary.main : theme.palette.primary.main,
    borderRadius: "6px",
  }),
  colorPrimary: {
    backgroundColor: "#E8E8E8",
  },
}));

export default function ModuleProgressBar({
  value = 0,
  name,
  className,
  fullWidth = false,
}: ModuleProgressBarProps) {
  const classes = useStyles({ value, name, fullWidth });

  const renderValue = Number.isNaN(value) ? 0 : value;

  return (
    <LinearProgress
      aria-label={`Module Progress for ${name}`}
      classes={{
        root: classNames(classes.moduleProgressBar, className),
        colorPrimary: classes.colorPrimary,
        barColorPrimary: classes.barColorPrimary,
      }}
      variant="determinate"
      value={renderValue}
    />
  );
}
